import { db, ILang, LANG_ID } from './db'

export const setLang = async (data: Omit<ILang, 'id'>) => {
  try {
    await db.lang.update(LANG_ID, data).then((res) => {
      if (res === 0) {
        return db.lang.add({
          id: LANG_ID,
          ...data
        })
      }
    })
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
  }
}

export const getLang = async () => {
  try {
    return await db.lang.where({ id: LANG_ID }).first()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
    return undefined
  }
}
